export interface MoneyLike {
	amount: string;
	currencyCode: string;
}

const DEFAULT_MONEY_LOCALE = 'en-US';
const REST_OF_WORLD_MONEY_LOCALE = 'en-001';

function getBrowserMoneyLocale() {
	if (typeof document === 'undefined') return DEFAULT_MONEY_LOCALE;

	const marketCookie = document.cookie
		.split('; ')
		.find((cookie) => cookie.startsWith('storefrontMarket='))
		?.split('=')[1];

	try {
		return decodeURIComponent(marketCookie ?? '').toLowerCase() === 'en/row'
			? REST_OF_WORLD_MONEY_LOCALE
			: DEFAULT_MONEY_LOCALE;
	} catch {
		return DEFAULT_MONEY_LOCALE;
	}
}

export function formatMoney(money: MoneyLike, locale = getBrowserMoneyLocale()) {
	return new Intl.NumberFormat(locale, {
		style: 'currency',
		currency: money.currencyCode,
	}).format(Number.parseFloat(money.amount));
}

export function formatMoneyAmount(
	amount: number,
	currencyCode: string,
	locale = getBrowserMoneyLocale(),
) {
	return new Intl.NumberFormat(locale, {
		style: 'currency',
		currency: currencyCode,
	}).format(amount);
}

/**
 * Price divided across units, e.g. a $45 32-stick box → "$1.41". Callers append
 * the unit ("/ stick"). Falls back to the undivided price when units is not a
 * positive number.
 */
export function formatPerUnitPrice(money: MoneyLike, units: number, locale?: string) {
	const amount = Number.parseFloat(money.amount);
	if (!Number.isFinite(amount) || !Number.isFinite(units) || units <= 0) {
		return formatMoney(money, locale);
	}
	return formatMoneyAmount(amount / units, money.currencyCode, locale);
}
